import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_2 = { class: "w-100 text-center" }
const _hoisted_3 = { class: "order-details-image b-white100 m-auto pointer d-flex a-i-center j-content-center pointer" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "w-100 d-flex a-i-center j-content-start" }
const _hoisted_6 = { class: "w-100 d-flex a-i-center j-content-center text-center w-100" }
const _hoisted_7 = { class: "w-100 d-flex a-i-center j-content-center text-center w-100" }
const _hoisted_8 = { class: "w-100 d-flex a-i-center j-content-center text-center w-100" }
const _hoisted_9 = { class: "w-100 d-flex a-i-center j-content-center text-center w-100" }
const _hoisted_10 = { class: "w-100 d-flex a-i-center j-content-center text-center w-100" }
const _hoisted_11 = { class: "w-100 d-flex a-i-center j-content-center text-center w-100" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, null, -1)

import { IResultDataSearch, CARS, TRUCK } from "@/store/modules/Search/type";
import SelectNumberCart from "@/components/select/SelectNumberCart.vue";
import { newWindow } from "@/utils/newWindow/newWindow";
import { ICartCars } from "@/store/modules/Cart/type";
import { toRefs, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'resultsComponentKK',
  props: {
    info: {},
    cart: {}
  },
  setup(__props: any) {

const props = __props;


const openNewTab = () => newWindow(data.info.value.product_tyre);
const link = ref(process.env.VUE_APP_SERVER);
const data = toRefs(props);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["orders-table-filter_results-kk transition-015 a-i-center pt-1 pb-1 no-select", { 'bg-white50': _unref(data).cart.value || false }])
  }, [
    _hoisted_1,
    _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(data).info.value?.product_tyre?.external_product_id || "No info"), 1),
    _createElementVNode("span", _hoisted_3, [
      _createElementVNode("img", {
        class: "image-order",
        src: 
          (_unref(data).info.value?.product_photo_path &&
            link.value + _unref(data).info.value?.product_photo_path) ||
          require('@/assets/' + 'no_image.jpg')
        ,
        onClick: openNewTab,
        alt: _unref(data).info.value?.product_full_name
      }, null, 8, _hoisted_4)
    ]),
    _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(data).info.value?.product_full_name || "No info"), 1),
    _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(data).info.value?.stock_name || "No info"), 1),
    _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(data).info.value?.stock_delivery_time || "No info"), 1),
    _createElementVNode("span", _hoisted_8, [
      _withDirectives(_createElementVNode("input", {
        type: "checkbox",
        disabled: "",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(data).info.value.price_inc_vat) = $event))
      }, null, 512), [
        [_vModelCheckbox, _unref(data).info.value.price_inc_vat]
      ])
    ]),
    _createElementVNode("span", _hoisted_9, _toDisplayString(Number(
        _unref(data).info.value.price_inc_vat
          ? _unref(data)?.info.value?.price_with_vat
          : _unref(data)?.info.value?.price_without_vat
      ).toFixed(2) || "No info"), 1),
    _createElementVNode("span", _hoisted_10, _toDisplayString(Number(_unref(data).info.value?.amount).toFixed(0) || "On order"), 1),
    _createElementVNode("span", _hoisted_11, [
      _createVNode(SelectNumberCart, {
        button: true,
        class: _normalizeClass('input-quantity'),
        id: _unref(data).info.value.product_tyre.id,
        placeholder: _unref(data)?.cart?.value?.amount?.toString() || '0',
        min: 0,
        max: 
          Number(_unref(data).info.value?.amount) > 0
            ? Number(_unref(data).info.value?.amount)
            : 0
        ,
        step: _unref(data).info.value.product_classificator === 2 ? 4 : 1,
        value: {
          price_inc_vat: _unref(data).info.value?.price_inc_vat,
          ..._unref(data).info.value.product_tyre,
        },
        stock: _ctx.info.stock_id
      }, null, 8, ["id", "placeholder", "max", "step", "value", "stock"])
    ]),
    _hoisted_12
  ], 2))
}
}

})